import React from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../components/layouts/Layout'
import VedikshhaSection from '../components/Vedikshha/VedikshhaSection'
import VedikshhaMysticalSection from '../components/Vedikshha/VedikshhaMysticalSection'
import HeroSlider from '../components/HeroSlider'
import YouTubeGridAutoPlay from '../components/YouTubeGridAutoPlay'
import SubscribePopup from '../components/SubscribePopup'
import { VLOGO } from '../utils/helper'


function Vedikshha() {
  return (
    <div>
      <Helmet> <title>Kaanshi Films Entertainment (KFE) | Film & Video Production House Mumbai - Vedikshha</title> </Helmet>
       <Layout>
            <div className="flex bg-green-50 justify-center items-center h-[40vh]">
              <img src={VLOGO} className='h-[250px]' alt="Main logo" />
            </div>
            <SubscribePopup/>
            <VedikshhaSection/>
            <YouTubeGridAutoPlay />
            <VedikshhaMysticalSection/>
       </Layout>
    </div>
  )
}

export default Vedikshha
